module.exports = __webpack_public_path__ + "img/p1-pic.fa96c15c.jpg";